import React, { useState, useContext } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Grid, Button, Accordion, Box, Typography } from '@material-ui/core'
import EditIcon from "@material-ui/icons/Edit"
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import { FieldArray } from 'formik'
import { useMediaQuery } from 'react-responsive'
import SummaryPassenger from 'components/Accordion/Summary/SummaryPassenger'
import DetailsPassenger from 'components/Accordion/Details/DetailsPassenger'
import styles from 'assets/jss/views/eventPageSections/generalEventsStyles.js'
import Context from 'context/Context'

const useStyles = makeStyles(styles)

const PassengerTab = (props) => {
  const [expanded, setExpanded] = useState('panel0')
  const { counties, validateForm, setActiveStep } = props
  const quantity = []
  const contextType = useContext(Context)
  const { t } = contextType

  const classes = useStyles()
  const isMobile = useMediaQuery({ query: '(max-width: 959px)' })

  const handleChange = (panel) => (event) => {
    event.preventDefault()
    setExpanded(expanded === panel ? false : panel)
  }

  const getCommuneName = (commune_id) => {
    
    const selectedCommune = counties.find((element) => element.id === commune_id)
    return selectedCommune.name
  }

  return (
    <div>
      <FieldArray>
        {(fieldArrayProps) => {
          const { form } = fieldArrayProps
          const { values } = form
          let tickets = values.tickets

          return (
            <>
              <Grid justify="space-between" alignItems="center" container>
                <Typography
                  classes={{ root: classes.addressTitle }}
                  className={isMobile ? classes.fs18 : classes.fs20}
                >
                  {t("who_travels")}
                </Typography>
                <Button
                  classes={{ root: classes.buttonEditTicket }}
                  className={isMobile ? classes.fs14 : classes.fs16}
                  startIcon={<ArrowBackIcon />}
                  onClick={() => setActiveStep(1)}
                >
                  {t("go_back")}
                </Button>
              </Grid>

              {tickets.map((ticket, index) => {
                quantity.push(ticket.passengers.length)

                const updatePassengers = (newPassenger) => {
                  ticket.passengers.slice(index, 1, newPassenger)
                }

                const addresses = ticket.addresses.map((element) => `${element.address}, ${getCommuneName(element.commune_id)}`)

                return (
                  <div key={index}>
                    <Box classes={{ root: classes.boxTickets }} id={index} data-ticket-id={index}>
                      <Accordion
                        expanded={expanded === `panel${index}`}
                        classes={{
                          root: classes.accordion,
                          rounded: classes.boxAddressOptionBorder,
                        }}
                      >
                        <SummaryPassenger
                          index={index}
                          capacity={ticket.capacity}
                          expanded={expanded === `panel${index}`}
                          name={ticket.name}
                          quantity={quantity[index]}
                          subcategoryName={ticket.subcategoryName}
                          handleChange={handleChange}
                          placeAddress={ticket.placeAddress}
                        />
                        <DetailsPassenger
                          updatePassengers={updatePassengers}
                          ticket={ticket}
                          addresses={addresses}
                          index={index}
                          validateForm={validateForm}
                        />
                      </Accordion>
                    </Box>
                  </div>
                )
              })}
            </>
          )
        }}
      </FieldArray>
    </div>
  )
}

export default PassengerTab
